<template>
    <div>
        <loading-gdb :propObject="results_loading" text="Carregando avaliações do colaborador" />
        <loading-gdb :propObject="$store.state.rh.colaboradores_loading" text="Carregando Colaboradores" />
        
        
        <v-row>

            <!-- Questionário(PeriodoQuest) -->
            <v-col cols="12" sm="12">
                <!-- <pre>{{computedColaboradores.length}} {{$store.state.rh.colaboradores_loading}}</pre> -->
                <v-autocomplete clearable hide-details return-object
                    density="comfortable"
                    :custom-filter="filterColaborador"
                    label="Selecione colaborador..."
                    v-model="selectedColaborador"
                    @update:modelValue="onChangeColaborador"
                    no-data-text="Nenhum colaborador carregado"
                    :items="computedColaboradores"
                    :loading="$store.state.rh.colaboradores_loading"
                    item-title="nome"
                    >
                    <template v-slot:append>
                        <v-btn class="mt-n1" @click="get_colaboradores">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:selection="data">
                        <span class="text-grey"><b>{{data.item.title}}</b></span>
                    </template>

                    <template v-slot:item="data">
                        <template v-if="!(typeof(data.item.raw) == 'object')">
                        </template>
                        <template v-else>
                            <v-list-item v-bind="data.props" color="primary">
                                <v-list-item-subtitle>
                                    <div>
                                        <b class="text-primary text-caption">                                    
                                            {{data.item.raw.alocado_em}} 
                                        </b>
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item>
                        </template>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-divider class="my"></v-divider>
            <!-- Listagem por Colaborador -->
            <v-col cols="12" sm="12">
                <div v-if="selectedColaborador && selectedColaborador.id">
                    <!-- Colaborador -->
                    <div style="line-height: 1.5;" class="py-2">
                        <div class="py-0 my-0" style="font-size:12px;font-weight:700">
                            <span class="text-primary">
                                {{selectedColaborador.alocado_em}} 
                                <b>{{selectedColaborador.chapa}}</b>
                            </span>
                        </div>
                        <div class="text-primary" style="font-size:16px; font-weight:700">
                            {{selectedColaborador.nome}}
                        </div>
                    </div>

                    <v-card class="my-2" variant="outlined"
                        v-for="referencia, ref_index in selectedColaborador.results"
                        :key="'refs_chart_'+ref_index">
                        <v-card-text>
                            <v-row class="px-1">
                                <div style="align-self: center;">
                                    <div>
                                      <b>{{referencia.periodo_label}} </b>
                                    </div>
                                    <div v-html="referencia.questionario_titulo"></div>
                                    <div class="text-caption">
                                        Avaliado por {{referencia.avaliado_por}}
                                    </div>
                                    <div class="text-caption text-disabled">
                                        Em: {{$verify.formatarData(referencia.created_at)}}
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn-small icon @click="openPreviewQuestionario(referencia)" title="Visualizar Questionário">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn-small>
                                <v-btn-small icon @click="removerAvaliacao(referencia.id)" title="Remover avaliação" color="error">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn-small>
                            </v-row>
                            <div v-if="referencia.total !== null">
                                <span class="pa-4">
                                    <helper-gdb 
                                        text="<div>- Até 20 pontos = <b>Limitado</b></div>
                                            <div>- De 21 a 28 pontos = <b>Básico</b></div>
                                            <div>- De 29 a 32 pontos = <b>Avançado</b></div>
                                            <div>- Acima de 32 = <b>Proficiente</b></div>"></helper-gdb>
                                </span>
                                <chart-gdb :dataOptions="resultsToBarChartOptions(selectedColaborador, referencia)"/>
                            </div>
                        </v-card-text>
                    </v-card>
                    <div v-if="((selectedColaborador||{}).results||[]).length === 0">
                        Nenhuma avaliação disponível para este colaborador
                    </div>
                </div>
            </v-col>
        </v-row>

        <!-- Modal de colabs -->
        <modal-gdb ref="modal_preview_questionario_rh"
            code="modal_preview_questionario_rh" fullscreen
            :toolbar-title="selectedQuest.questionario_titulo+' - '+selectedQuest.avaliado"
            dialogWidth="100%">
            <template v-slot:activate-slot>
                <span></span>
            </template>
            <template v-slot:body>
                <div>
                  <PreviewMentorias :selectedQuest="selectedQuest" :classificar_avaliacao="classificar_avaliacao"/>
                </div>
            </template>
        </modal-gdb>
    </div>
</template>

<script>
import PreviewMentorias from './PreviewMentorias.vue';

export default {
  components: {
    PreviewMentorias,
  },
  name: 'RHColaboradoresComponent',
  data(){
    return {
        teste:null,
      SINGLE: 'single',
      TEXT: 'text',
      colaboradores: [],
      selectedSetor: {},
      selectedColaborador: null,
      chart_type: 'bar',
      selectedQuest: {},
      results_loading: false,
    }
  },
  methods: {
    openPreviewQuestionario(quest){
        this.selectedQuest = Object.assign({}, quest)
        this.$refs.modal_preview_questionario_rh.dialog = true
    },
    closePreviewQuestionario(){
        this.$refs.modal_preview_questionario_rh.dialog = false
        this.selectedQuest = Object.assign({}, {})
    },
    async get_colaboradores(){
        // Carregar todos os colaboradores
        await this.$store.dispatch('GetRHColaboradores', {})
    },
    async get_colaborador_results(colaborador){
        // Carregar todos os colaboradores
        this.results_loading = true
        const colab_results = await this.$store.dispatch('GetRHColaboradorResults', colaborador)
        this.results_loading = false
        return colab_results
    },
    init(){
        this.get_colaboradores()
    },
    async onChangeColaborador(colaborador){
        this.selectedColaborador = await this.get_colaborador_results(colaborador)
    },
    classificar_avaliacao(pontos){
      /*
        - Até 20 pontos = limitado
        - De 20 a 28 pontos = básico
        - De 28 a 32 pontos = avançado
        - Acima de 32 = proficiente
      */
      if(pontos <= 20){
        return `${'Limitado'}`; //return `${'Limitado'} (${pontos})`;
      }else if (pontos <= 28){
        return `${'Básico'}`;
      }else if (pontos <= 32){
        return `${'Avançado'}`;
      }else{
        return `${'Proficiente'}`;
      }
    },
    filterColaborador(item, queryText, itemText){
        item // titulo do item (nome do colaborador)
        queryText // texto digitado
        itemText // item obj da lista 
        const searchText = (queryText||'').toLowerCase()
        const setor = (itemText.raw.alocado_em||'').toLowerCase().indexOf(searchText) !== -1
        const nome = (itemText.raw.nome||'').toLowerCase().indexOf(searchText) !== -1 
        return setor || nome
    },
    resultsToBarChartOptions(colaborador, questionario){
      const chartOptions = {
        series: [],
        options: {
          // colors:['#81B7CC', '#29657D', '#9FE2FC', '#53CDFD','#4F707D'],
          chart: {
            type: this.chart_type,
            height: 280,
            stacked:true,
            width: colaborador.results.length <= 2 ? '50%' : '100%',
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          responsive: [
            {
              breakpoint: 768,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                },
                chart: {
                  height: 280,
                  width: '100%',
                }
              }
            },
            {
              breakpoint: 1000,
              options: {
                legend: {
                  position: 'right',
                  offsetX: -10,
                  offsetY: 0
                },
                chart: {
                  height: 280,
                  width: colaborador.results.length <= 2 ? '65%' : '100%'
                }
              }
            },
            {
              breakpoint: 2000,
              options: {
                legend: {
                  position: 'right',
                  offsetX: -10,
                  offsetY: 0
                },
                chart: {
                  height: 280,
                  width: colaborador.results.length <= 3 ? '70%' : '100%'
                }
              }
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              dataLabels: {
                total: {
                    enabled: true, // Resultado das classificaoes totais
                    style: {
                        fontSize: '10px',
                        fontWeight: 600
                    },
                    formatter: (v, opts) => {
                        opts
                        return this.classificar_avaliacao(v)
                    }
                }
              }
            },
          },
          xaxis: {
            type: 'string',
            categories: [],
          },
          legend: {
            position: 'right',
            // offsetY: 40,
            show: true
          },
          fill: {
            opacity: 0.9
          },
          title: {
            text: '', // Avaliação
          },
          dataLabels: {
            enabled: false, /* Exibe os indicadores individuais no gráfico */
            enabledOnSeries: undefined,
            // formatter: function (val, opts) {
            //   opts
            //   console.log(val, opts)
            //     return opts.w.config.series[opts.seriesIndex].name
            // },
            style: {
                fontSize: '10px',
                fontWeight: 'normal',
            },
          }
        },
      }
      /* Trecho original que compõe a união dos gráficos */
      /*
      colaborador.results
        .filter(r => r.total !== null) // Não incluir avaliações subjetivas(questionários de total null)    
        .forEach(questionario => {
        questionario.respostas.forEach(resposta => {
          const competenciaIndex = chartOptions.series.findIndex(series => series.name === resposta.competencia.nome);
          // console.log('--', colaborador.nome, resposta.competencia.nome, competenciaIndex)
          if (competenciaIndex === -1) {
            chartOptions.series.push({
              name: resposta.competencia.nome,
              data: [resposta.value]
            })
          } else {
            if(resposta.tipo === this.SINGLE){
              chartOptions.series[competenciaIndex].data.push(resposta.value);
            }
            if(resposta.tipo === this.TEXT){
              chartOptions.series[competenciaIndex].data.push(resposta.peso);
            }
          }
          if (!chartOptions.options.xaxis.categories.includes(questionario.periodo_label)) {
            chartOptions.options.xaxis.categories.push(questionario.periodo_label);
          }
        })
      })
      */
        questionario.respostas.filter(r => r.value !== null).forEach(resposta => {
            const competenciaIndex = chartOptions.series.findIndex(series => series.name === resposta.competencia.nome);
            // console.log('--', colaborador.nome, resposta.competencia.nome, competenciaIndex)
            if (competenciaIndex === -1) {
            chartOptions.series.push({
                name: resposta.competencia.nome,
                data: [resposta.value]
            })
            } else {
            if(resposta.tipo === this.SINGLE){
                chartOptions.series[competenciaIndex].data.push(resposta.value);
            }
            if(resposta.tipo === this.TEXT){
                chartOptions.series[competenciaIndex].data.push(resposta.peso);
            }
            }
            if (!chartOptions.options.xaxis.categories.includes(questionario.periodo_label)) {
            chartOptions.options.xaxis.categories.push(questionario.periodo_label);
            }
        })
      return chartOptions
    },
    async removerAvaliacao(id){
      const conf = confirm('Tem certeza que deseja remover esta avaliação?')
      if (!conf) return
      const deleted = await this.$store.dispatch('RHRemoverAvaliacaoColaborador', id)
      if (!deleted) return
      const colab = Object.assign({}, this.selectedColaborador)
      this.selectedColaborador = await this.get_colaborador_results(colab)
    }
  },
  computed:{
    computedColaboradores(){
      return this.$store.state.rh.colaboradores
    },
    computedSetores(){
      return this.$store.state.user.setores
    }
  },
  mounted(){
    this.init()
  },
  watch: {
    computedSetores: {
      handler(value){
        value
        this.selectedSetor = Object.assign({}, {})
      }, deep: false
    }
  }
}
</script>
<style scoped>
  .links{
    text-decoration: none;
  }
</style>